var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"product-component-1690719788398","product-id":_vm.productId,"color":_vm.primaryColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }